const ITEMS = [
  "Rim Refurb",
  "Full Blackout",
  "Leather Rewrap",
  "Alcantara Pillars",
  "Headlight Restoration",
  "Vinyl Weld",
  "Two-Tone Chrome & Silver",
  "Carpet Velour",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <div key={item} className="flex items-center">
        <span className="font-syne font-bold uppercase tracking-[0.2em] text-xl sm:text-2xl text-slate-600 px-8 whitespace-nowrap">
          {item}
        </span>
        <span className="w-1.5 h-1.5 rounded-full bg-volt shadow-[0_0_10px_rgba(0,240,255,0.9)]" />
      </div>
    ))}
  </div>
);

const MarqueeSection = () => (
  <div
    data-testid="marquee-container"
    className="relative border-y border-edge bg-surface/40 py-6 overflow-hidden"
  >
    <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
      <Row />
      <Row />
    </div>
  </div>
);

export default MarqueeSection;
